var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('img',{staticClass:"bgImg pcShow",attrs:{"src":require("@/assets/images/recruit/recruit_detail_pc.png")}}),_vm._v(" "),_c('img',{staticClass:"bgImg mobileShow",attrs:{"src":require("@/assets/images/recruit/recruit_detail.png")}}),_vm._v(" "),_c('online-service')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abf620c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecruitDetail.vue
// module id = null
// module chunks = 